/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
import React, { useEffect, useState,useMemo } from "react";
import axios from "axios";
import ProfileImg from '../../../assets/profile.png'

// Hosts that actually serve /.netlify/functions/api-proxy. Optimizers like
// NitroPack rehost the widget JS on the WordPress origin while keeping the
// original tools host inside the rewritten path, so match a known host
// anywhere in the src rather than trusting the URL's origin.
const TOOLS_HOSTS = ["tools.unclekam.com", "tools-unclekam.netlify.app"];

function toolsOriginFromSrc(src) {
  if (!src) return "";
  try {
    const u = new URL(src, location.href);
    if (TOOLS_HOSTS.includes(u.hostname)) return u.origin;
  } catch {}
  for (const host of TOOLS_HOSTS) {
    if (src.includes(`/${host}/`) || src.includes(`//${host}/`)) {
      return `https://${host}`;
    }
  }
  return "";
}

function detectToolsOrigin() {
  const fromCur = toolsOriginFromSrc(document.currentScript && document.currentScript.src);
  if (fromCur) return fromCur;
  const scripts = Array.from(document.getElementsByTagName("script"));
  for (let i = scripts.length - 1; i >= 0; i--) {
    const fromScan = toolsOriginFromSrc(scripts[i].src || "");
    if (fromScan) return fromScan;
  }
  const isQA = new URLSearchParams(location.search).has("qa_mode");
  return isQA ? "https://tools-unclekam.netlify.app" : "https://tools.unclekam.com";
}

const cleintUrlProd = "https://app.unclekam.com";
const cleintUrlStaging = "https://staging.unclekam.com";
// const cleintUrlStaging = "http://localhost:3000";


const TaxPros = ({qa_mode,redirectUrl, state, roundRobin}) => {
  const [taxPros, setTaxPros] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState("");
    const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const qa = useMemo(() => (typeof qa_mode === "boolean" ? qa_mode : params.has("qa_mode")), [qa_mode, params]);

  const CLIENT_URL = qa ? cleintUrlStaging : cleintUrlProd;


    const PROXY_URL =
    window.__UK_PROXY_URL__ ||
    `${detectToolsOrigin()}/.netlify/functions/api-proxy`;
    
  useEffect(() => {
    const fetchTaxPros = async () => {
      try {
        setLoading(true);
        setError("");

        const stateParam = (state || "")
          .trim()
          .toUpperCase();

        const res = await axios.post(
          PROXY_URL,
          {
            path: "/getListOfTaxPros",
            method: "POST",
            qa_mode: qa,
            data: { state: stateParam, roundRobin: roundRobin },
          },
          { headers: { "Content-Type": "application/json" } }
        );

        const payload = res.data?.data || res.data || {};
        const list = payload.taxPros || [];
        setTaxPros(list);
      } catch (err) {
        console.error("TaxPros fetch error:", err);
        setError("Failed to load tax professionals.");
      } finally {
        setLoading(false);
      }
    };

    fetchTaxPros();
  }, [PROXY_URL, qa, state, roundRobin]);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-warning mb-3" role="status" />
        <div>Loading tax professionals...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5 text-center text-danger">
        {error}
      </div>
    );
  }

  if (!taxPros.length) {
    return (
      <div className="container py-5 text-center">
        No tax professionals found.
      </div>
    );
  }

  const getAvatarUrl = (pro) => {
    const avatar =
      pro?.user?.avatar &&
      (Array.isArray(pro.user.avatar)
        ? pro.user.avatar[0]
        : pro.user.avatar);
    return avatar?.path || ProfileImg;
  };

  return (
    <div className="container my-4">
      {taxPros.map((pro) => {
        const fullName = `${pro?.user?.firstname || ""} ${
          pro?.user?.lastname || ""
        }`.trim();
        const rawCredential = (pro?.type || "").trim();
        const credential =
          rawCredential.toLowerCase() === "none" ? "" : rawCredential;
        const license = pro?.state_license_id;
        const years = pro?.years_of_experience;
    
        const expertiseList =
          pro?.additional?.expertise ||
          pro?.expertise ||
          [];

        return (
          <div
            key={pro.id}
            className="card mb-4 border-0 shadow-sm rounded-4"
            style={{ backgroundColor: "#dee1d8" }}
          >
            <div className="card-body px-4 py-4">
              <div className="row align-items-start">
                {/* Avatar */}
                <div className="col-md-2 text-end mb-3 mb-md-0 d-flex justify-content-md-end justify-content-center">
                  <div
                    className="rounded-circle overflow-hidden "
                    style={{ width: 130, height: 130 }}
                  >
                    <img
                      src={getAvatarUrl(pro) || ProfileImg}
                      alt={fullName || "Tax Professional"}
                      className="img-fluid h-100 w-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="col-md-10">
                  <h5 className="mb-1 fw-bold">
                    {fullName || "Tax Professional"}
                    {credential ? `, ${credential}` : ""}
                  </h5>

                  <div className="text-muted  mt-2 mb-1">
                    MERNA<span className="fw-bold">™</span> Certified Tax
                    Strategist
                  </div>

                  {license && (
                    <div className="text-muted  mb-1">License: {license}</div>
                  )}

                  {Array.isArray(expertiseList) && expertiseList.length > 0 && (
                    <div className="mb-2">
                      {expertiseList.map((tag, idx) => (
                        <span
                          key={idx}
                          className="badge rounded-pill bg-success-subtle text-success fw-semibold me-2 mb-2"
                        >
                          {tag?.label || tag?.name || String(tag)}
                        </span>
                      ))}
                    </div>
                  )}
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    {pro?.services?.length > 0 &&
                      pro?.services?.map((service, index) => (
                        <div
                          key={index}
                          className="mb-2 bg-secondary py-1 px-3  rounded-4 fw-semibold text-start"
                          style={{fontSize:'12px'}}
                        >
                          {service?.name}
                        </div>
                      ))}
                  </div>

                  {years ? (
                    <div className="text-muted fw-semibold mt-2 mb-2">
                      {years} {years === 1 ? "year" : "years"} of experience
                    </div>
                  ) : null}

                  {pro?.experience && (
                    <p className="my-3 text-black fw-medium fs-6">
                      {pro.experience?.substring(0, 380)}{pro.experience?.length > 380 ? "..." : ""}
                    </p>
                  )}

                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-warning fw-semibold px-4"
                      onClick={() => {
                        const base = redirectUrl || "https://unclekam.com";

                        const url = new URL(base);
                        url.searchParams.set("pro_id", pro?.uuid);
                        if (qa) url.searchParams.set("qa_mode", "on");

                        const win = window.open(url.toString(), "_blank");

                        if (!win) {
                          window.location.href = url.toString();
                        }
                      }}
                    >
                      Get Started
                    </button>
                    <a
                      href={`${CLIENT_URL}/profile/${pro?.user?.firstname}${pro?.user?.lastname}/${pro?.uuid}`}
                      type="button"
                      className="btn btn-outline-grey-300 text-black fw-semibold px-4"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Profile
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TaxPros;
